import { render } from "./dependents-incorporation-no-deliverable-form-error.vue?vue&type=template&id=060ed3c0"
const script = {}

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__